import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ToolboxSaveNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.525 11.7H8.325C7.1672 11.7 6.225 12.6422 6.225 13.8V19.8H8.025V13.8C8.025 13.6348 8.1598 13.5 8.325 13.5H15.525C15.6914 13.5 15.825 13.6348 15.825 13.8V19.8H17.625V13.8C17.625 12.6422 16.6828 11.7 15.525 11.7Z"
        fill={color}
      />
      <path
        d="M8.1 10.2H15.3C15.6314 10.2 15.9 9.93135 15.9 9.59995V4.19995H7.4999V9.59995C7.4999 9.93135 7.7686 10.2 8.1 10.2Z"
        fill={color}
      />
      <path d="M19.8 19.8H4.2V22.2001H19.8V19.8Z" fill={color} />
      <path
        d="M21.4971 5.50295L18.4971 2.50295C18.047 2.05285 17.4366 1.80005 16.8 1.80005H4.2C2.8746 1.80005 1.8 2.87455 1.8 4.20005H16.8L19.8 7.20005V22.2001C21.1255 22.2001 22.2 21.1255 22.2 19.8V7.20005C22.2 6.56355 21.9471 5.95305 21.4971 5.50295Z"
        fill={color}
      />
      <path
        d="M1.8 4.19995V19.8C1.8 21.1255 2.8746 22.2 4.2 22.2V4.19995H1.8Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolboxSaveNsk.displayName = 'ToolboxSaveNsk';
